import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { enqueueSnackbar } from 'notistack';

import { getResolvedEndpoint } from '@/api/utils/getResolvedEndpoint';
import { handleApiCall } from '@/api/utils/handleApiCall';
import { MutationStateFns } from '@/api/utils/mutation';
import { Id } from '@/api/utils/sql';
import { useAuth } from '@/context/AuthProvider';

export type ApiResponse_Resolve_Ticket = {
  ticketId: Id;
  resolved: true;
};

export type ApiRequest_Resolve_Ticket = {
  ticketId: Id;
};

const METHOD = 'POST';
const ENDPOINT = 'ticket/:id/resolve';

export const useResolveTicket = (stateFns?: MutationStateFns<ApiResponse_Resolve_Ticket>) => {
  const { session } = useAuth();

  return useMutation({
    mutationFn: async (data: ApiRequest_Resolve_Ticket) =>
      handleApiCall<ApiResponse_Resolve_Ticket>(
        session,
        METHOD,
        getResolvedEndpoint(ENDPOINT, { id: data.ticketId.toString() })
      ),
    onSuccess: data => {
      enqueueSnackbar('Ticket resolved successfully', { variant: 'success' });

      stateFns?.onSuccess?.(data);
    },
    onError: (err: AxiosError) => {
      enqueueSnackbar('Failed to resolve ticket', { variant: 'error' });

      // eslint-disable-next-line no-console
      console.error(err);
      stateFns?.onError?.(err);
    },
  });
};
